import { BASE_HANDLER_URL } from ".";
import { DEFAULT_GRID_INFO_MERGE } from "../Components/TicketDetail/MergeTickets/KendoMergeTicketGrid";

export const loadMergeTicketGridData = async (
  filterData,
  gridState,
  sharedData
) => {
  document.getElementById("loader").style.display = "block";
  const currentSize = gridState.pageSize ?? DEFAULT_GRID_INFO_MERGE.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_MERGE.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_MERGE.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", gridState.pageNumber);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      TXTALLKEYWORDS: filterData.keyword ? filterData.keyword.trim() : "",
      Reporter: filterData.reporter ? filterData.reporter.trim() : "",
      TXTALLSTATUS: filterData.status ? filterData.status.trim() : "",
      TXTALLASSIGNEE: filterData.assignee ? filterData.assignee.trim() : "",
      TXTPRACTICENAME: filterData.practiceName
        ? filterData.practiceName.trim()
        : "",
      ticketCategory: filterData.ticketCategory
        ? filterData.ticketCategory.trim()
        : "",
      TXTALLPRIORITY: filterData.priority ? filterData.priority.trim() : "",
      teamCategory: filterData.teamCategory
        ? filterData.teamCategory.trim()
        : "",
      followDays: filterData.followDays ? filterData.followDays.trim() : "",
      priorityClients: filterData.priorityClient
        ? filterData.priorityClient.trim()
        : "",
      StatusDays: filterData.statusDays ? filterData.statusDays.trim() : "",
      txtInternalAssignee: filterData.internalAssignee
        ? filterData.internalAssignee.trim()
        : "",
      ParentTicket: sharedData.currentTicketNo ?? "",
      suspended: filterData.suspended ? filterData.suspended.trim() : "",
      CustAccNum: filterData.mergeCustomerId ? filterData.mergeCustomerId : "",
      client: filterData.clientId ? filterData.clientId.trim() : "",
      FromDate: filterData.fromDate ? filterData.fromDate.trim() : "",
      ToDate: filterData.toDate ? filterData.toDate.trim() : "",
      TargetDate: filterData.targetDate ? filterData.targetDate.trim() : "",
      overDue: filterData.overDue ? filterData.overDue.trim() : "",
      ddlTeam: filterData.team ? filterData.team.trim() : "",
      userType: sessionStorage.type ?? "",
      CP: sessionStorage.CP ?? "",
      APPUSER: sessionStorage.USER ?? "",
      Reseller: sessionStorage.Reseller ?? "",
      entitySeqNum: filterData.entityId ?? "",
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_MERGE.className
    }&action=${DEFAULT_GRID_INFO_MERGE.action}&${
      queryParams ? `${queryParams}` : ""
    }`;
    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });
    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    }
    // LoadData();
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
